import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTable } from "@angular/material/table";
import { ACTION_ALERT, DataType, IActionAlert, IFilter } from "@comunicare/comunicare-interfaces";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { RuleAlert } from "src/app/models/rule-alert.model";
import { SessionService } from "src/app/providers/session.service";
import { AlertHistoricDataSource } from "./alert-historic-datasource";

@Component({
  selector: "app-alert-details-historic",
  templateUrl: "./alert-details-historic.component.html",
  styleUrls: ["./alert-details-historic.component.scss"],
})
export class AlertDetailsHistoricComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() alert: RuleAlert;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatTable) table: MatTable<IActionAlert>;

  public dataSource: AlertHistoricDataSource;
  /** Raw active filters, kept in sync to feed `app-item-filter` via the `filterFor` pipe. */
  public activeFilters: IFilter[] = [];
  public displayedColumns: string[] = ["date", "action", "author", "comment"];
  public dataTypeText = DataType.TEXT;
  public dataTypeDate = DataType.DATE;
  public dataTypeChoice = DataType.CHOICE;
  /** Subject that emits when the component has been destroyed. */
  // eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-denylist, id-match
  private onDestroy$ = new Subject<void>();

  public constructor(private sessionService: SessionService) {
    this.sessionService.refreshAlertDetailsDataList.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
      this.dataSource.loadData(this.alert);
    });
  }

  ngOnInit() {
    this.dataSource = new AlertHistoricDataSource(this.alert);
    this.dataSource.loadData(this.alert);
  }

  ngAfterViewInit(): void {
    this.initPaginatorAndSort();
  }
  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  public getComment(actionHistory: IActionAlert) {
    const comment = this.alert?.notes?.[actionHistory.commentId]?.text;
    if (comment?.length > 100) {
      return comment.substring(0, 100) + "...";
    } else {
      return comment;
    }
  }

  public getTranslations(actions: ACTION_ALERT[]) {
    return this.alert.getActionTranslateKey(actions);
  }

  private initPaginatorAndSort() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  public applyFilter(filter: IFilter) {
    this.dataSource.setFilter(filter);
    this.activeFilters = [...(this.dataSource?.getAllFilters() ?? [])];
  }

  public getFilter(propertyName: string) {
    return this.dataSource.getFilter(propertyName);
  }
}
